<template>
    <template v-for="(item, x) in items" :key="`${x}-group`">

        <div class="flex flex-col  gap-4 mb-4  items-start ">
            <div class="w-full">
                <GroupCard v-model:inputs="inputs" v-model:errors="errors" v-model:form="items[x]"
                    :group-by="`${column}.${x}.`" v-model:option="option"
                    @set-child="(e, input) => setChild(e, input, column, x)" @update-data="showMessage"
                    @set-filter="(e, input) => setFilter(e, input, column, x)">
                </GroupCard>
            </div>
            <div class="items-start">
                <Button @click="items.splice(x, 1)" severity="danger" :label="$t('delete')" icon="pi pi-trash">
                </Button>
            </div>
        </div>

    </template>
    <div class="flex flex-col">
        <div class="">
            <Button v-if="items.length < count" :label="$t('add')" icon="pi pi-plus"
                @click="items.push(JSON.parse(JSON.stringify(props.form)))">

            </Button>
        </div>

    </div>
</template>

<script setup>






import GroupCard from '@/Builder/Components/GroupCard.vue';
import { ref } from 'vue';
import pkg from 'lodash';
const { debounce } = pkg;


const props = defineProps({
    inputs: {
        type: Array,
        required: true,
    },
    form: {
        type: Object,
        required: true,
    },
    count: {
        type: Number,
        required: true,
    },
    option: {
        type: Object,
        required: true,
    },
    column: {
        type: String,
        required: true,
    },


})



const items = defineModel('items');
const errors = defineModel('errors');

const inputs = ref(props.inputs);
const option = ref(props.option);




const setChild = (e, input, column, x) => {
    if (input.childColumn) {
        props.form[column][x][input.childColumn] = null;
        router.post(option.value.child, { child: e.value, column: input.childColumn }, {
            onSuccess: (page) => {
                inputs.value = page.props.fields.inputs;
            }
        })
    }
};


const fetchResults = debounce((value, column) => {
    router.post(option.value.filter, { value: value, column: column }, {
        onSuccess: (page) => {
            inputs.value = page.props.fields.inputs;
        }
    })
}, 1000);
const setFilter = (e, input, column, x) => {
    if (input.filter) {
        input.loading = true;
        fetchResults(e.target.value, input.column);
    }
};


const showMessage = () => {
    form.clearErrors();
};





</script>
